function scrollToRef(ref: React.MutableRefObject<HTMLElement | null>) {
	if (ref && ref.current) ref.current.scrollIntoView({ behavior: 'smooth' })
}

export { scrollToRef }
